import type { ISensemakerListCard } from '@brushfire/types'

export type SensemakerStatusFilter = 'all' | 'active' | 'deactivated' | 'expired' | 'near_token_limit'

export type SensemakerPackageFilter = 'all' | '01' | '02' | '03'

export interface SensemakerListFilterState {
  search: string
  status: SensemakerStatusFilter
  package: SensemakerPackageFilter
}

export const DEFAULT_SENSEMAKER_LIST_FILTERS: SensemakerListFilterState = {
  search: '',
  status: 'all',
  package: 'all',
}

export function filterSensemakerCards(
  items: ISensemakerListCard[],
  filters: SensemakerListFilterState,
): ISensemakerListCard[] {
  const search = filters.search.trim().toLowerCase()

  return items.filter((card) => {
    if (search && !card.tenantName.toLowerCase().includes(search)) {
      return false
    }

    if (filters.status !== 'all') {
      if (filters.status === 'near_token_limit' && !card.nearTokenLimit) {
        return false
      }
      if (
        filters.status !== 'near_token_limit' &&
        card.status !== filters.status
      ) {
        return false
      }
    }

    // Package filter is intentionally a no-op until real package plans exist (BFP-520).
    void filters.package

    return true
  })
}

export function applyQuickStatFilter(
  current: SensemakerListFilterState,
  pill: 'active' | 'deactivated' | 'expired' | 'near_token_limit',
): SensemakerListFilterState {
  return { ...current, status: pill }
}
